import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import fitvids from 'fitvids';
import ReactPlayer from 'react-player';

import { ModalContentWrapper } from './ModalNote';
import Title from './Title';

fitvids();

const PlayerWrapper = styled('div')`
  position: relative;
  padding-top: 56.25%;
  margin-top: 30px;
`;

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute !important;
  top: 0;
  left: 0;
`;

class ModalVideo extends PureComponent {
  componentDidMount() {
  }

  render() {
    const {
      name,
      video,
    } = this.props;

    let mediaUrl = video;
    if (mediaUrl && mediaUrl.includes('drive.google')) {
      const split = mediaUrl.split('/');
      const id = split[split.length - 2];
      mediaUrl = `https://drive.google.com/uc?export=download&id=${id}`;
    }
    return (
      <ModalContentWrapper>
        <Title
          icon='video'
        >
          {name}
        </Title>
        <PlayerWrapper>
          <StyledReactPlayer
            className='react-player'
            url={mediaUrl}
            controls
            width='100%'
            height='100%'
            style={{ backgroundColor: 'black' }}
          />
        </PlayerWrapper>
      </ModalContentWrapper>
    );
  }
}

ModalVideo.propTypes = {
  name: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
};

export default ModalVideo;
